/* src/app/private/components/student/delete-student/delete-student.component.scss */
/*# sourceMappingURL=delete-student.component.css.map */
